import Vue from 'vue';
import Component from 'vue-class-component';
import Ribbon from '@/core/ribbon/ribbon.vue';
import SlmNavbar from '@/core/slm-navbar/slm-navbar.vue';
import SlmSideNavbar from '@/core/slm-sidenav/slm-sidenav.vue';
import SlmRightSideNavbar from '@/core/slm-right-sidenav/slm-right-sidenav.vue';

import AccountService from '@/account/account.service';

import '@/shared/config/dayjs';
import { Inject, Watch } from 'vue-property-decorator';
import { INotif } from './shared/model/global.model';

@Component({
  components: {
    ribbon: Ribbon,
    'slm-navbar': SlmNavbar,
    'slm-sidenav': SlmSideNavbar,
    'slm-right-sidenav': SlmRightSideNavbar,
  },
})
export default class App extends Vue {
  @Inject('accountService') private accountService: () => AccountService;
  public isLoggedIn = false;

  public mounted() {
    this.$nextTick(function () {
      this.$store.commit('showLoading', false);
      this.$store.commit('setDrawer', false);
      this.$store.commit('setRightDrawer', false);
      this.$store.commit('clearAllNotif');
      this.hasAnyAuthority();
    });
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  @Watch('$store.showLoading')
  public get isLoading(): boolean {
    return this.$store.getters.showLoading;
  }

  public hasAnyAuthority(): boolean {
    const authorities = ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_EMPLOYEE'];
    this.accountService()
      .hasAnyAuthorityAndCheckAuth(authorities)
      .then(value => {
        this.isLoggedIn = value;
      });
    return this.isLoggedIn;
  }

  public get snackbars(): INotif[] {
    return this.$store.getters.notifs;
  }

  public calcSnackbarMargin(index) {
    return index * 60 + 'px';
  }

  public removeSnackbar(index?: number) {
    this.$store.commit('removeNotif', index);
  }
}
